import React from 'react';
import iconify from '../iconify';

const SvgAttention = props => (
  <svg width={8.809} height={28.701} {...props}>
    <g data-name="Group 892">
      <g data-name="Group 884">
        <path
          data-name="Path 528"
          d="M5.515 28.451H3.443a2.438 2.438 0 01-2.435-2.436v-1.943a2.438 2.438 0 012.435-2.435h2.072a2.438 2.438 0 012.436 2.435v1.943a2.438 2.438 0 01-2.436 2.436zm-2.072-5.9a1.52 1.52 0 00-1.519 1.518v1.943a1.52 1.52 0 001.519 1.519h2.072a1.52 1.52 0 001.519-1.519v-1.943a1.52 1.52 0 00-1.519-1.518z"
          fill="#e64a50"
          stroke="#e64a50"
          strokeWidth={0.5}
        />
      </g>
      <g data-name="Group 885">
        <path
          data-name="Path 529"
          d="M5.596 19.507H3.21a1.56 1.56 0 01-1.558-1.558l-1.4-16.1a1.567 1.567 0 011.557-1.6h5.194a1.56 1.56 0 011.558 1.558L7.155 17.996a1.548 1.548 0 01-1.559 1.511zM1.806 1.255a.55.55 0 00-.549.549l1.4 16.1a.563.563 0 00.551.592h2.386a.55.55 0 00.549-.549L7.549 1.758a.546.546 0 00-.551-.5z"
          fill="#e64a50"
          stroke="#e64a50"
          strokeWidth={0.5}
        />
      </g>
    </g>
  </svg>
);

export default iconify(SvgAttention);
